<template>
  <div class="product-list">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Select v-model="formItem.showroom_id"
                  clearable
                  filterable
                  placeholder="选择展厅">
            <Option v-for="item in showroomlist"
                    :value="item.id"
                    :key="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Input v-model="formItem.key"
                 clearable
                 placeholder="输入商品名称查找..."></Input>
        </FormItem>
        <FormItem>
          <Select v-model="formItem.status"
                  clearable
                  placeholder="选择状态">
            <Option v-for="item in statusList"
                    :value="item.id"
                    :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable('formItem')">查找</Button>
        </FormItem>

        <FormItem>
          <Button @click="showModel()"
                  type="success"
                  class="f-l">添加</Button>
        </FormItem>
        <FormItem>
          <Button @click="getexport()"
                  type="success"
                  :loading='exportLoading'
                  class="f-r">导出藏品兑换码</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="list"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <Drawer :title="title"
            v-model="showModalStatus"
            width="1200"
            :mask-closable="false"
            :styles="styles">
      <Form :model="goods"
            :label-width="80"
            ref="goodsValidate"
            :rules="goodsValidate">
        <Row>
          <Col span="8">
          <FormItem label="商品类型"
                    label-position="top">
            <Select v-model="goods.type_id"
                    clearable
                    filterable
                    placeholder="选择类型"
                    @on-change="typeChange">
              <Option v-for="item in typeList"
                      :value="item.id"
                      :key="item.id">{{item.name}}</Option>
            </Select>
          </FormItem>
          </Col>
          <!-- <Col span="8">
          <FormItem label="商品分类"
                    label-position="top">
            <Select v-model="goods.cate_id"
                    clearable
                    filterable
                    placeholder="选择分类">
              <Option v-for="item in cateList"
                      :value="item.id"
                      :key="item.id">{{item.name}}</Option>
            </Select>
          </FormItem>
          </Col> -->
          <Col span="8">
          <FormItem label="展厅"
                    label-position="top">
            <Select v-model="goods.showroom_id"
                    clearable
                    filterable
                    placeholder="选择展厅">
              <Option v-for="item in showroomlist"
                      :value="item.id"
                      :key="item.id">{{item.name}}</Option>
            </Select>
          </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
          <FormItem label="标题"
                    label-position="top"
                    prop="name">
            <Input v-model="goods.name"
                   placeholder="商品标题">></Input>
          </FormItem>
          </Col>
          <Col span="8">
          <FormItem label="库存"
                    label-position="top"
                    prop="store">
            <Input v-model="goods.store"></Input>
          </FormItem>
          </Col>
          <Col span="8">
          <FormItem label="价格"
                    label-position="top"
                    prop="price">
            <Input v-model="goods.price"></Input>
          </FormItem>
          </Col>
        </Row>

        <FormItem label="关键字"
                  label-position="top"
                  prop="keyword">
          <Input v-model="goods.keyword"></Input>
        </FormItem>
        <FormItem label="标签"
                  label-position="top">
          <Input v-model="goods.tag"
                 placeholder="多个标签用，隔开"></Input>
        </FormItem>
        <FormItem label="描述"
                  label-position="top"
                  prop="describe">
          <Input type="textarea"
                 v-model="goods.describe"
                 :rows="3"
                 placeholder="请输入描述" />
        </FormItem>

        <Row>
          <Col span="6">
          <FormItem label="上架时间"
                    prop="on_time">
            <DatePicker v-model="goods.on_time"
                        type="datetime"
                        format="yyyy-MM-dd hh:mm:ss"
                        placeholder="上架时间"
                        style="width: 200px"
                        @on-change="changeDateOne"></DatePicker>
          </FormItem>
          </Col>
          <Col span="6">
          <FormItem label="下架时间"
                    prop="off_time">
            <DatePicker v-model="goods.off_time"
                        type="datetime"
                        format="yyyy-MM-dd hh:mm:ss"
                        placeholder="下架时间"
                        style="width: 200px"
                        @on-change="changeDateTwo"></DatePicker>
          </FormItem>
          </Col>
          <Col span="6">
          <FormItem label="可购买时间"
                    prop="start_time">
            <DatePicker v-model="goods.start_time"
                        type="datetime"
                        format="yyyy-MM-dd hh:mm:ss"
                        placeholder="可购买时间"
                        style="width: 200px"
                        @on-change="changeDateThree"></DatePicker>
          </FormItem>
          </Col>
          <Col span="6">
          <FormItem label="结束购买时间"
                    prop="end_time">
            <DatePicker v-model="goods.end_time"
                        type="datetime"
                        format="yyyy-MM-dd hh:mm:ss"
                        placeholder="结束购买时间"
                        style="width: 200px"
                        @on-change="changeDateFour"></DatePicker>
          </FormItem>
          </Col>
        </Row>
        <FormItem label="缩略图">
          <upload-thumb v-model="goods.thumb"
                        ref="uploadthumb"
                        :defaultList="thumblist"
                        tip="<span style='color:#ff2121'>图片格式:jpg、jpeg、png,<br>建议图片尺寸:670*600,大小不超过2M</span>"></upload-thumb>
        </FormItem>
        <FormItem label="模型文件"
                  v-if="showModelFile">
          <zip-import v-model="goods.model_file"
                      ref="uploadZip"
                      :defaultList="ziplist"></zip-import>
        </FormItem>
        <FormItem label="上传音频或视频"
                  v-if="showModelMp4">
          <file-import v-model="goods.url"
                       :format="['mp3','mp4']"
                       :defaultList="fujianlist"
                       ref="import-files"></file-import>
        </FormItem>
        <FormItem label="内容"
                  prop="content">
          <UEditor v-model="goods.content"
                   ref="editContent"></UEditor>
        </FormItem>
      </Form>
      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px"
                @click="showModalStatus = false">取消</Button>
        <Button type="primary"
                @click="creategoods('goodsValidate')">提交</Button>
      </div>
    </Drawer>
  </div>
</template>

<script>
import UploadThumb from "../common/thumb"
import UEditor from '../common/ueditor';
import fileImport from "../common/uploadFile";
import zipImport from "../common/uploadzip"

export default {
  name: 'product-list',
  data () {
    const validateThumb = (rule, value, callback) => {
      if (this.$refs["uploadthumb"].uploadList.length == 0) {
        callback(new Error('请上传缩略图'));
      } else {
        callback();
      }
    };
    const validateThumbTwo = (rule, value, callback) => {
      if (this.$refs["uploadthumbTwo"].uploadList.length == 0) {
        callback(new Error('请上传模型文件'));
      } else {
        callback();
      }
    };
    const validateContent = (rule, value, callback) => {
      if (this.goods.content == '') {
        callback(new Error('内容必须填写'));
      } else {
        callback();
      }
    };
    const validateStore = (rule, value, callback) => {
      if (this.goods.store == '') {
        callback(new Error('库存必须填写'));
      } else {
        callback();
      }
    };
    const validatePrice = (rule, value, callback) => {
      if (this.goods.price == '') {
        callback(new Error('价格必须填写'));
      } else {
        callback();
      }
    };
    return {
      styles: {
        height: 'calc(100% - 55px)',
        overflow: 'auto',
        paddingBottom: '53px',
        position: 'static'
      },
      statusList: [
        { id: 1, name: "正常" },
        { id: 0, name: "禁用" }
      ],
      goods: {
        name: '',
        keyword: '',
        describe: '',
        content: '',
        tag: "",
        thumb: '',
        model_file: '',
        price: '',
        on_time: '',
        off_time: '',
        start_time: '',
        end_time: '',
      },
      editor: {
        ifno: '',
      },
      loading: true,
      dataloading: true,
      showModelFile: false,
      showModelMp4: false,
      exportLoading: false,
      thumblist: [],
      fujianlist: [],
      ziplist: [],
      cateList: [], // 请求分类
      typeList: [],
      showroomlist: [],
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      title: '',
      formItem: {
        'key': '',
        'showroom_id': "",
        'status': ""
      },
      list: [
        {
          title: 'Id',
          key: 'id',
          fixed: 'left',
          width: 90
        },
        {
          title: '标题',
          key: 'name',
          minWidth: 300
        },
        {
          title: '兑换码',
          key: 'exchange_code',
          minWidth: 150,
        },
        {
          title: '类型',
          key: 'typename',
          minWidth: 150,
          render: (h, params) => {
            return h('div', [
              h('span', {
              }, params.row.type.name)
            ]);
          }
        },
        {
          title: '展厅',
          key: 'roomname',
          minWidth: 150,
          render: (h, params) => {
            return h('div', [
              h('span', {
              }, params.row.showroom.name)
            ]);
          }
        },
        {
          title: '库存',
          key: 'store',
          minWidth: 80,
        },
        {
          title: '销量',
          key: 'sale',
          minWidth: 80,
        },

        {
          title: '操作',
          key: 'action',
          width: 200,
          align: 'left',
          fixed: 'right',
          render: (h, params) => {
            if (params.row.status == 1) {
              return h('div', [
                h('Button', {
                  style: {
                    marginRight: '8px'
                  },
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.detail(params.row.id)
                    }
                  }
                }, '编辑'),
                h('Button', {
                  style: {
                    marginRight: '8px'
                  },
                  props: {
                    type: 'warning',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.status(params.row.id, 0)
                    }
                  }
                }, '下架')
              ]);
            } else {
              return h('div', [
                h('Button', {
                  style: {
                    marginRight: '8px'
                  },
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.detail(params.row.id)
                    }
                  }
                }, '编辑'),
                h('Button', {
                  style: {
                    marginRight: '8px'
                  },
                  props: {
                    type: 'warning',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.status(params.row.id, 1)
                    }
                  }
                }, '上架')
              ]);
            }

          }
        }
      ],
      tablelist: [],
      showModalStatus: false,
      goodsValidate:
      {
        name: [
          { required: true, message: "名称必须填写", trigger: "blur" }
        ],
        store: [
          { required: true, validator: validateStore, trigger: "blur" }
        ],
        price: [
          { required: true, validator: validatePrice, trigger: "blur" }
        ],
        keyword: [
          { required: true, message: "关键词必须填写", trigger: "blur" }
        ],
        describe:
          [
            { required: true, message: "描述必须填写", trigger: "blur" }
          ],

        on_time: [

          {
            required: true,
            validator: (rule, value, callback) => {
              if (this.goods.on_time == '') {
                callback(new Error('上架时间必须填写'));
              } else {
                callback();
              }
            }, trigger: "change"
          }
        ],
        off_time: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (this.goods.on_time == '') {
                callback(new Error('下架时间必须填写'));
              } else {
                callback();
              }
            }, trigger: "change"
          }
        ],
        start_time: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (this.goods.start_time == '') {
                callback(new Error('可购买时间必须填写'));
              } else {
                callback();
              }
            }, trigger: "change"
          }
        ],
        end_time: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (this.goods.end_time == '') {
                callback(new Error('结束购买时间必须填写'));
              } else {
                callback();
              }
            }, trigger: "change"
          }
        ],
        content:
          [
            { required: true, validator: validateContent, trigger: "change" }
          ],
      },
      id: 0,

    }
  },
  created: function () {
    this.getTableList();
    this.getShowRoomList();
  },
  components: {
    UploadThumb,
    UEditor,
    fileImport,
    zipImport
  },

  methods: {
    getTableList: function () {
      this.$api.product.list({ "page": this.pages.page, "size": this.pages.size }).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    getShowRoomList () {
      this.$api.showroom.list({ "page": 1, "size": 50 }).then(res => {
        if (res.code == 200) {
          this.showroomlist = res.result.list;
        }
      });
    },
    // 获取分类getCate
    getCate: function () {
      this.$api.numprocate.list({ 'page': 1, 'size': 100 }).then(res => {
        if (res.code == 200) {
          this.cateList = res.result.list;
        }
      });
      return;
    },
    getType: function () {
      this.$api.numprotype.list({ 'page': 1, 'size': 100 }).then(res => {
        if (res.code == 200) {
          this.typeList = res.result.list;
        }
      });
      return;
    },
    changeDateTwo (val) {
      this.goods.off_time = val;
    },
    changeDateOne (val) {
      this.goods.on_time = val;
    },
    changeDateThree (val) {
      this.goods.start_time = val;
    },
    changeDateFour (val) {
      this.goods.end_time = val;
    },
    // 展开添加
    showModel () {
      this.tempId = (new Date().getTime() / 1000).toFixed();
      this.getCate();
      this.getType();
      this.title = "添加商品";
      this.goods = {
        name: '',
        keyword: '',
        describe: '',
        content: '',
        tag: "",
        thumb: '',
        model_file: '',
        price: '',
        on_time: '',
        off_time: '',
        start_time: '',
        end_time: '',
      };
      this.thumblist = new Array();
      this.fujianlist = new Array();
      this.ziplist = new Array();
      this.selectCate = [];
      this.$refs['goodsValidate'].resetFields();
      this.$refs['editContent'].message = '';
      this.showModalStatus = !this.showModalStatus;
    },
    // 详情
    detail (id) {
      this.title = "编辑商品";
      this.getShowRoomList();
      this.getCate();
      this.getType();
      this.thumblist = new Array();
      this.fujianlist = new Array();
      this.ziplist = new Array();
      this.$refs['goodsValidate'].resetFields();
      this.showModalStatus = !this.showModalStatus;
      this.$api.product.detail({ id: id }).then(res => {
        this.goods = res.result;
        this.typeChange(this.goods.type_id);
        this.$refs['editContent'].message = res.result.content;
        if (this.goods.thumb != null && this.goods.thumb != '') {
          this.thumblist.push({
            name: this.goods.thumb,
            url: this.goods.thumb,
            status: 'finished',
          });
        }

        if (this.goods.model_file != null && this.goods.model_file.length > 0) {
          this.ziplist.push({
            name: this.goods.model_file,
            url: this.goods.model_file,
            status: "finished"
          });
        }
        if (this.goods.url != null && this.goods.url.length > 0) {
          for (var s in this.goods.attrShow) {
            this.fujianlist.push({
              name: this.goods.attrShow[s],
              url: this.goods.attrShow[s],
              status: "finished"
            });
          }
        }
      });
    },
    // 添加
    creategoods (name) {
      this.goods.content = this.$refs['editContent'].message;
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (this.$refs['uploadthumb'].uploadList.length > 0) {
            this.goods.thumb = this.$refs['uploadthumb'].uploadList[0].url;
          }
          if (this.$refs["uploadZip"] && this.$refs["uploadZip"].resList.length > 0) {
            var tList = this.$refs["uploadZip"].resList;
            if (tList[0].response && tList[0].response.result) {
              this.goods.model_file = tList[0].response.result.model_file;
              this.goods.obj = tList[0].response.result.obj;
              this.goods.mtl = tList[0].response.result.mtl;
            } else {
              this.goods.model_file = this.goods.model_file
              this.goods.obj = this.goods.obj;
              this.goods.mtl = this.goods.mtl;
            }
          } else {
            this.goods.model_file = "";
            this.goods.obj = "";
            this.goods.mtl = "";
          }
          if (this.goods.on_time instanceof Date) {
            this.goods.on_time = this.formatDate(
              this.goods.on_time,
              "yyyy-MM-dd hh:mm:ss"
            );
          }
          if (this.goods.off_time instanceof Date) {
            this.goods.off_time = this.formatDate(
              this.goods.off_time,
              "yyyy-MM-dd hh:mm:ss"
            );
          }
          if (this.goods.start_time instanceof Date) {
            this.goods.start_time = this.formatDate(
              this.goods.start_time,
              "yyyy-MM-dd hh:mm:ss"
            );
          }
          if (this.goods.end_time instanceof Date) {
            this.goods.end_time = this.formatDate(
              this.goods.end_time,
              "yyyy-MM-dd hh:mm:ss"
            );
          }

          if (this.goods.id == null || this.goods.id == 0 || this.goods.id == undefined) {
            if (this.$refs["import-files"] && this.$refs["import-files"].resList.length > 0) {
              var finalAttrs = "";
              var tList = this.$refs["import-files"].resList;
              for (var s in tList) {
                finalAttrs = finalAttrs + tList[s].response.result.url + ",";
              }
              if (finalAttrs != "") {
                this.goods.url = finalAttrs.substring(
                  0,
                  finalAttrs.length - 1
                );
              }
            } else {
              this.goods.url = ""
            }
            this.$api.product.create(this.goods).then(res => {
              if (res.code == 200) {
                this.getTableList();
              }
              this.loading = false;
              this.$nextTick(() => { this.loading = true; });
              this.showModalStatus = !this.showModalStatus;
            });
          } else {
            if (this.$refs["import-files"] && this.$refs["import-files"].resList.length > 0) {
              var finalAttrs = "";
              var tList = this.$refs["import-files"].resList;
              for (var s in tList) {
                if (tList[s].url != "") {
                  finalAttrs = finalAttrs + tList[s].url + ",";
                } else {
                  if (
                    tList[s].response &&
                    tList[s].response.result &&
                    tList[s].response.result.url != ""
                  ) {
                    finalAttrs = finalAttrs + tList[s].response.result.url + ",";
                  } else {
                    finalAttrs = finalAttrs;
                  }
                }
              }
              if (finalAttrs != "") {
                this.goods.url = finalAttrs.substring(
                  0,
                  finalAttrs.length - 1
                );
              } else {
                this.goods.url = "";
              }
            } else {
              this.goods.url = "";
            }
            this.$api.product.edit(this.goods).then(res => {
              if (res.code == 200) {
                this.getTableList();
              }
              this.loading = false;
              this.$nextTick(() => { this.loading = true; });
              this.showModalStatus = !this.showModalStatus;
            });
          }
        } else {
          this.$Message.error('请检查输入的信息是否正确！');
          this.loading = false
          this.$nextTick(() => { this.loading = true; });
        }
      })
    },
    // 删除
    status: function (id, index) {
      this.$api.product.status({ id: id, status: index }).then(res => {
        if (res.code == 200) {
          this.$Message.success(res.msg);
          this.getTableList();
        }
      });
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs['listPage'].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        key: this.formItem.key,
        showroom_id: this.formItem.showroom_id,
        status: this.formItem.status,
        page: this.pages.page,
        size: this.pages.size,
      };
      this.$api.product.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    formatDate (tt, fmt) {
      if (null == tt || '' == tt)
        return '';
      var date = new Date(tt);
      let o = {
        'M+': date.getMonth() + 1, // 月份
        'd+': date.getDate(), // 日
        'h+': date.getHours(), // 小时
        'm+': date.getMinutes(), // 分
        's+': date.getSeconds(), // 秒
        'S': date.getMilliseconds() // 毫秒
      }
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
      }
      for (var k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
        }
      }
      return fmt
    },
    typeChange (value) {
      console.log("value", value);
      if (value == 1) {
        this.showModelFile = true;
        this.showModelMp4 = false;
      } else if (value == 3) {
        this.showModelFile = false;
        this.showModelMp4 = false;
      } else {
        this.showModelFile = false;
        this.showModelMp4 = true;
      }
    },
    getexport: function () {
      var ps = {
        key: this.formItem.key,
        showroom_id: this.formItem.showroom_id,
        status: this.formItem.status,
      };

      this.exportLoading = true;
      this.$api.product.export(ps).then(res => {
        if (res.code == 200) {
          this.exportLoading = false;
          window.location.href = res.result;
        }

      })
    },
  },
}
</script>

<style>
.demo-drawer-footer {
  width: 100%;
  height: 50px;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
</style>
